/** Shared constants for the modification import flow. */

export const IMPORT_MAX_FILE_BYTES = 10 * 1024 * 1024; // 10 MB
export const IMPORT_MAX_ANALYZE_CHARS = 500_000;

export const IMPORT_ALLOWED_EXTENSIONS = [
  '.txt',
  '.csv',
  '.pdf',
  '.json',
  '.xlsx',
  '.xls',
] as const;

/** User-facing step labels (Add → Organize → Review → Done). */
export const IMPORT_STEP_LABELS = {
  input: 'Add list',
  review: 'Review',
  importing: 'Adding',
  complete: 'Done',
} as const;

export const IMPORT_PRIMARY_EXAMPLE = `Engine
- Manley 9:1 Pistons
- Bosch 84mm Throttle Body

Wheels and Tires
- Desmond Regamaster EVO II
  - 18x9.5 +22`;

export interface ImportHistorySession {
  session_token: string;
  status: string;
  imported_modifications: number;
  total_modifications: number;
  parse_source?: string | null;
  can_undo?: boolean;
  created_at?: string;
  completed_at?: string | null;
}

export interface SmartSuggestionFields {
  cost?: number;
  vendor?: string;
  category?: string;
}
